import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';
import BVContainerLoader from '../../BVContainerLoader/bv-container-loader';

type BVCustomerPricesImportProps = {
	fileList: UploadFile[];
	setFileList: (list: UploadFile[]) => void;
	uploadCustomerPricesExcel: (file: File) => Promise<void>;
	loading: boolean;
	resetCustomerPricesUploadState: () => void;
};

const BVCustomerPricesImport = ({
	fileList,
	setFileList,
	uploadCustomerPricesExcel,
	loading,
	resetCustomerPricesUploadState,
}: BVCustomerPricesImportProps) => {
	const beforeUpload = (file: RcFile) => {
		if (!file.name.endsWith('.xls') && !file.name.endsWith('.xlsx')) {
			return Upload.LIST_IGNORE;
		}

		resetCustomerPricesUploadState();
		setFileList([
			{ uid: file.uid, name: file.name, status: 'done', originFileObj: file },
		]);
		return false;
	};

	const upload = async () => {
		const f = fileList[0]?.originFileObj;
		if (!f) return;
		await uploadCustomerPricesExcel(f as File);
	};

	return (
		<div className="admin-card">
			<div className="admin-row-3">
				<label className="admin-label">Import Customers&apos; prices</label>

				<Upload
					beforeUpload={beforeUpload}
					fileList={fileList}
					maxCount={1}
					onRemove={() => setFileList([])}
					accept=".xls,.xlsx"
				>
					<Button icon={<UploadOutlined />}>Select File</Button>
				</Upload>

				<BVContainerLoader loading={loading} />

				<Button
					type="primary"
					onClick={upload}
					disabled={fileList.length === 0 || loading}
				>
					Upload File
				</Button>
			</div>
		</div>
	);
};

export default BVCustomerPricesImport;
